import { useEffect, useState } from "react";
import { navItems } from "@/mocks/gossip";

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "sticky top-0 z-40 w-full transition-colors duration-300 border-b " +
        (scrolled
          ? "bg-background-50/95 backdrop-blur border-background-200"
          : "bg-background-50/70 backdrop-blur-sm border-transparent")
      }
    >
      <div className="mx-auto flex h-14 md:h-16 items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-fire-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-base md:text-lg font-bold text-foreground-950">黑料吃瓜网</span>
            <span className="block text-[10px] md:text-xs text-foreground-500 tracking-widest">吃瓜群众聚集地</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1" aria-label="页面分区导航">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a
            href="#group"
            className="flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 dark:text-foreground-950 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-group-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            加入吃瓜群
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden flex items-center justify-center w-9 h-9 rounded-md text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <nav className="mx-auto grid grid-cols-2 gap-2 px-4 py-4" aria-label="移动端分区导航">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#group"
              onClick={() => setOpen(false)}
              className="col-span-2 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-3 py-2.5 text-sm font-medium text-background-50 dark:text-foreground-950 cursor-pointer"
            >
              <i className="ri-group-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              加入吃瓜群
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}